import { render, staticRenderFns } from "./CreatePostControls.vue?vue&type=template&id=5c39c75a&"
import script from "./CreatePostControls.vue?vue&type=script&lang=js&"
export * from "./CreatePostControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports